import EmailMetric from "../enums/EmailMetric";

export const safeDivide = (numerator: number, denominator: number): number | undefined => {
  if (denominator === 0) {
    return undefined;
  }
  return numerator / denominator;
};

export const PERCENT_METRICS: Readonly<EmailMetric[]> = [
  EmailMetric.CLICK_RATE,
  EmailMetric.OPEN_RATE,
  EmailMetric.REPLY_RATE,
];
